<template>
  <div class="fcp-page">
     <template v-if="from!='introDetail'">
        <Header />
        <div id="block"></div>
        <Box1 />
    </template>
    <Box2 />
    <Box3 />
    <Box4 />
    <Box5 />
    <Box6 @open="open"/>
    <Box7 />
    <Box8 />
    <Box9 />
    <Box10 />
    <Box11 />
    <Box12 />
    <Certification :visible.sync="visible" pageName="帆软FCP认证&培训"/>
    <pageRightFloat pageName="帆软FCP认证&培训"/>
    <Footer />
  </div>
</template>

<script>
import Certification from "../common/Certification.vue"
import pageRightFloat from "../common/pageRightFloat.vue";
import Header from "../common/Header.vue";
import Footer from "../common/Footer.vue";
import Box1 from "./box1.vue"
import Box2 from "./box2.vue"
import Box3 from "./box3.vue"
import Box4 from "./box4.vue"
import Box5 from "./box5.vue"
import Box6 from "./box6.vue"
import Box7 from "./box7.vue"
import Box8 from "./box8.vue"
import Box9 from "./box9.vue"
import Box10 from "./box10.vue"
import Box11 from "./box11.vue"
import Box12 from "./box12.vue"
export default {
  name: '',
  components:{
    Certification,
    pageRightFloat,
    Header,
    Footer,
    Box1,
    Box2,
    Box3,
    Box4,
    Box5,
    Box6,
    Box7,
    Box8,
    Box9,
    Box10,
    Box11,
    Box12
  },
  data() {
    return {
      visible: false,
      from:''
    }
  },
   mounted() {
   this.from=this.getQueryString("from")
  },
  methods: {
    open(){
      this.visible = true
    },
    zixun(name) {
      zhuge.track("H5_人工智能专题页", {
        咨询按钮名称: name,
      });
      // this.clickZiXun()
    },
  },
}
</script>
<style lang="scss">
body,html{
  overflow-x: hidden;
}

.van-toast{
  padding: 24px !important;
  max-width: 660px;
  border-radius: 18px !important;
  .van-toast__text{
    color: #fff;
    line-height: 32px !important;
    font-size: 28px !important;
  }
}
</style>
<style lang="scss" scoped>

#block {
  width: 100%;
  height: 88px;
}

::v-deep {
  // 模块标题
  
  .fcp-title{
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #24375C;
    line-height: 56px;
    text-align: center;
  }

  // 模块副标题1
  .fcp-stitle{
    margin-top: 48px;
    position: relative;
    display: flex;
    justify-content: center;
    height: 52px;
    span{
      display: inline-block;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #0066FF;
      line-height: 52px;
      position: relative;
      z-index: 2;
    }
    &:after{
      z-index: 1;
      content: "";
      position: absolute;
      bottom: 0px;
      left: 50%;
      transform: translateX(-50%);
      width: 100%;
      height: 20px;
      background: #DBEFFF;
    }
  }

  // 模块副标题2
  .fcp-text{
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4E5969;
    line-height: 40px;
    margin-top: 18px;
    text-align: center;
  }
}
</style>